export enum ProgramStatusEnum {
    completed = 'completed',
    ongoing = 'ongoing',
    canceled = 'canceled'
}
